<template>
  <nav class="navigation">
    <router-link to="/" style="text-decoration: none">
      <img src="@/assets/images/logo.svg" style="width: 100px; height: 35px;" alt="Rumie" />
    </router-link>
    <slot></slot>
    <div class="spacer"></div>

    <div class="navigation__dropdowns" v-on-click-outside="closeDropdown">
      <div @click="toggleHome()" class="nav__dropdown" :class="highlightHomeIcon">
        <i class="far fa-home-lg-alt navigation__icon"></i>
        <span>Home</span>
        <div class="navigation__dropdown--home--close" :class="visibleHomeDropdown">
          <router-link
            v-if="isStaff"
            class="navigation__dropdown-icon"
            to="/"
            style="text-decoration: none"
          >
            <!-- <img src="@/assets/images/home.svg" alt="Admin Analytics" /> -->
            Home
          </router-link>
          <a
            class="navigation__dropdown-icon"
            target="_blank"
            href="https://build.rumie.org"
            style="text-decoration: none"
          >
            <!-- <img src="@/assets/images/home.svg" alt="Admin Analytics" /> -->
            Rumie-Build
          </a>
          <a
            class="navigation__dropdown-icon"
            target="_blank"
            href="https://learn.rumie.org"
            style="text-decoration: none"
          >
            <!-- <img src="@/assets/images/home.svg" alt="Admin Analytics" /> -->
            Rumie-Learn
          </a>
          <a
            target="_blank"
            href="https://rumie.org"
            v-if="isStaff"
            class="navigation__dropdown-icon"
            to="/admin/analytics"
            style="text-decoration: none"
          >
            <!-- <img src="@/assets/images/home.svg" alt="Admin Analytics" /> -->
            Rumie.org
          </a>
        </div>
      </div>

      <div @click="toggleLogout" class="nav__dropdown">
        <i class="far fa-user-circle navigation__icon"></i>
        <span>Account</span>
        <div class="navigation__dropdown--logout--close" :class="visibleLogoutDropdown">
          <router-link
            class="navigation__dropdown-icon"
            to="/analytics"
            style="text-decoration: none"
          >
            <!-- <img src="@/assets/images/analytics.svg" alt="Analytics" /> -->
            {{ user.email }}
          </router-link>
          <router-link
            class="navigation__dropdown-icon"
            :to="{name: 'Logout'}"
            style="text-decoration: none"
          >
            <!-- <img src="@/assets/images/logout.svg" alt="Logout" style="width:20px; height:22px;" /> -->
            Logout
          </router-link>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { mixin as onClickOutside } from "vue-on-click-outside";

export default {
  mixins: [onClickOutside],
  data() {
    return {
      analyticsDropdown: false,
      logoutDropdown: false,
      homeDropdown: false
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    isStaff() {
      return this.$store.getters.isStaff;
    },
    visibleAnalyticsDropdown() {
      return {
        "navigation__dropdown--analytics--open": this.analyticsDropdown
      };
    },
    visibleHomeDropdown() {
      return {
        "navigation__dropdown--home--open": this.homeDropdown
      };
    },
    visibleLogoutDropdown() {
      return {
        "navigation__dropdown--logout--open": this.logoutDropdown
      };
    },
    highlightHomeIcon() {
      return {
        "navigation-icon__highlight": this.$route.name === "ProjectList"
      };
    },
    highlightConnectIcon() {
      return {
        "navigation-icon__highlight": this.$route.name === "ProjectConnect"
      };
    },
    hasContentVisibility() {
      return !!(Object.keys(this.user).length > 0 && this.$store.state.auth.user.administrator_of_organizations.length > 0)
    }
  },
  methods: {
    closeDropdown() {
      this.analyticsDropdown = false;
      this.logoutDropdown = false;
      this.homeDropdown = false;
    },
    toggleAnalytics() {
      this.analyticsDropdown = !this.analyticsDropdown;
      this.logoutDropdown = false;
      this.homeDropdown = false;
    },
    toggleHome() {
      this.homeDropdown = !this.homeDropdown;
      this.logoutDropdown = false;
      this.analyticsDropdown = false;
    },
    toggleLogout() {
      this.logoutDropdown = !this.logoutDropdown;
      this.analyticsDropdown = false;
      this.homeDropdown = false;
    }
  }
};
</script>

<style scoped>
.navigation {
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  background: var(--white);
  box-shadow: var(--shadow-primary);
  padding: var(--spacing-2) var(--spacing-4);
}

.navigation__dropdowns {
  display: flex;
  flex-direction: row;
}

.nav__dropdown {
  display: flex;
  align-items: center;
  color: var(--tertiary);
  cursor: pointer;
  position: relative;
  margin-right: var(--spacing-3);
  font-size: var(--lg);
}

.nav__dropdown img {
  padding-right: var(--spacing-3);
}

.navigation__title {
  color: var(--primary);
}

.spacer {
  margin-left: auto;
  margin-right: auto;
}

.navigation-icon__menu {
  display: flex;
  font-size: var(--base);
  color: var(--tertiary);
  align-items: center;
  margin-left: var(--spacing-2);
}

.navigation-icon__highlight {
  color: var(--black);
}

.navigation__icon {
  cursor: pointer;
  font-size: var(--lg);
  align-items: center;
  margin-left: var(--spacing-2);
  --vertical-padding: var(--spacing-2);
  --horizontal-padding: var(--spacing-4);
  padding: var(--horizontal-padding) var(--vertical-padding)
    var(--horizontal-padding) 0;
}

.navigation__icon img {
  margin-right: var(--spacing-2);
}

.navigation__dropdown--analytics--close,
.navigation__dropdown--home--close,
.navigation__dropdown--logout--close {
  display: none;
}

.navigation__dropdown--analytics--open,
.navigation__dropdown--home--open,
.navigation__dropdown--logout--open {
  display: inline !important;
  position: absolute;
  min-width: 150px;
  background: var(--white);
  box-shadow: var(--shadow-md);
  right: 0;
  top: 50px;
  z-index: 1;
  white-space: nowrap;
  padding: var(--spacing-2) 0;
}

.navigation__dropdown--logout--open a,
.navigation__dropdown--home--open a,
.navigation__dropdown--analytics--open a {
  transition: 0.3s all;
  border-bottom: 1px solid var(--grey-lighter);
}

.navigation__dropdown--logout--open a:last-child,
.navigation__dropdown--home--open a:last-child,
.navigation__dropdown--analytics--open a:last-child {
  border: none;
}

.navigation__dropdown--logout--open a:hover,
.navigation__dropdown--home--open a:hover,
.navigation__dropdown--analytics--open a:hover {
  background: var(--grey-lighter);
}

.navigation__dropdown-icon {
  display: flex;
  font-size: var(--base);
  color: var(--grey-color-text);
  padding: var(--spacing-3) var(--spacing-4);
  align-items: center;
}

.navigation-dropdown__content {
  text-decoration: none;
  color: var(--grey-color-text);
}

@media screen and (max-width: 860px) {
  .navigation__icon {
    --vertical-padding: var(--spacing-2);
    --horizontal-padding: var(--spacing-2);
  }
  .navigation__icon span,
  .nav__dropdown span {
    display: none;
  }
}
</style>
